import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { itOperationCoreTargetSelectionSearchSchema } from './-zod-schema';

export const Route = createFileRoute(
  '/_staff/it-operation-core/person-targets/',
)({
  validateSearch: zodValidator(itOperationCoreTargetSelectionSearchSchema),
});
